// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Streaming = createSvgIcon(
  { LeftToRight: <React.Fragment><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M20.0711 5c3.9052 3.9053 3.9052 10.2369 0 14.1421M17.9497 7c2.7337 2.7337 2.7337 7.1658 0 9.8995M15.8284 9c1.5621 1.5621 1.5621 4.0948 0 5.6569" /><circle cx="12" cy="12" r="1" /><path d="M7.8288 14.6569c-1.5621-1.5621-1.5621-4.0948 0-5.6569M5.9497 16.8995C3.216 14.1658 3.216 9.7337 5.9497 7M4.0715 19.1421c-3.9052-3.9052-3.9052-10.2368 0-14.142" /></g><defs></defs></React.Fragment>, },
  'default'
);
